var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 5,
    fill: "none",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 30h59M1 50h59M1 70h59"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 50h31M77 33l18 18M77 67l18-19"
  }))));
}
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5IYW1idXJnZXIgbWVudTwvdGl0bGU+CiAgICA8ZyBpZD0iTGluZXMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjUiIGZpbGw9Im5vbmUiPgogICAgICAgIDxsaW5lIHgxPSIxIiB5MT0iMzAiIHgyPSI2MCIgeTI9IjMwIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj4KICAgICAgICA8L2xpbmU+CiAgICAgICAgPGxpbmUgeDE9IjEiIHkxPSI1MCIgeDI9IjYwIiB5Mj0iNTAiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiPgogICAgICAgIDwvbGluZT4KICAgICAgICA8bGluZSB4MT0iMSIgeTE9IjcwIiB4Mj0iNjAiIHkyPSI3MCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+CiAgICAgICAgPC9saW5lPgogICAgPC9nPgogICAgPGcgaWQ9IkFycm93IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSI1IiBmaWxsPSJub25lIj4KICAgICAgICA8bGluZSB4MT0iNjEiIHgyPSI5MiIgeTE9IjUwIiB5Mj0iNTAiIC8+CiAgICAgICAgPGxpbmUgeDE9Ijc3IiB4Mj0iOTUiIHkxPSIzMyIgeTI9IjUxIiAvPgogICAgICAgIDxsaW5lIHgxPSI3NyIgeDI9Ijk1IiB5MT0iNjciIHkyPSI0OCIgLz4KICAgIDwvZz4KPC9zdmc+";
export { SvgMenu as ReactComponent };